import React, { useMemo, useState } from "react"
import { Card, CardBody, CardTitle, Progress } from "reactstrap"
import ReactApexChart from 'react-apexcharts';

const GeneralTaskReport = ({ taskReport = [] }) => {

  // const [state, setState] = useState();

  const totalTasks = taskReport?.reduce((acc, curr) => (acc + curr.value), 0)

  const chartData = useMemo(() => {
    if (taskReport.length) {
      return (
        {
          series: taskReport.map(t => t.value),
          options: {
            chart: {
              width: 380,
              type: 'pie',
            },
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 270
              }
            },
            dataLabels: {
              enabled: false
            },
            fill: {
              type: 'gradient',
            },
            colors: taskReport.map(t => t.color), // Color codes for each segment
            labels: taskReport.map(t => t.title),
            legend: {
              formatter: function (val, opts) {
                return val + " - " + opts.w.globals.series[opts.seriesIndex];
              }
            },
            title: {
              text: `Total Task - ${totalTasks}`
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          }
        }
      )
    } else return null
  }, [taskReport]) 

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">General Tasks Report</CardTitle>

          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-center align-items-center">
                {
                  chartData ?
                  <ReactApexChart options={chartData?.options} series={chartData?.series} type="pie" width={600} />
                  : <div>Report Not Available!</div>
                }
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default GeneralTaskReport
